<template>
    <div class="grid scroll-div ">
        <div class="grid-title bg-primary">
            <h4 class="text-bold text-white">
                Soon Sold Out
            </h4>
            <FabricCalculationInfo>
                <template #title>This table show the fabrics which switch their status next to sold out</template>
                <template #content>
                    <div class="calculation-info-container">
                        <div class="title">Est. Sold out date</div>
                        <div class="description">
							Estimated sold out date is the date when the fabric is expected to be sold out or unavailable for purchase.
							<br />
              				If fabric is overwritten, then it will show 'Overwritten'
						</div>
                        <code>
                            CONST LENGTH_UNTIL_SOLD_OUT_STATUS_TRIGGERED = 30;<br/>
                            $average = max($averageUsage30days, $averageUsage60days, $averageSale30days, $averageSale60days);<br/>
                            $daysLeftForStock = ($fabricInStock - LENGTH_UNTIL_SOLD_OUT_STATUS_TRIGGERED) / $average;<br/>
                            $result = formatDaysToDate($daysLeftForStock);
                        </code>
                    </div>
    
                    <div class="calculation-info-container">
                        <div class="title">Free stock</div>
                        <div class="description">Free stock is the length ( <i>In Meter</i> ) of fabric that is remaining.</div>
                        <code>
                            $fabricCutLength = $fabricCutLengthForEachOrder; <br/>
                            $fabricCutLengthForAllOrders = sum($fabricCutLength) <br/>
                            $result = $inStockLength - $fabricCutLengthForAllOrders;
                        </code>
                    </div>
                </template>
            </FabricCalculationInfo>
        </div>
        <div class="filters">
            <div class="tabs">
                <div v-for="futureFilter in futureFilterOptions" 
                    :key="futureFilter.value" 
                    @click="future = futureFilter.value; filterFabrics()" 
                    class="tab" :class="{'active': futureFilter.value == future}"
                >
                    {{futureFilter.name}}
                </div>
            </div>
            <select v-model="date" @change="filterFabrics()">
                <option 
                    v-for="dataFilter in dateFilterOptions" 
                    :value="dataFilter.value" 
                    :key="dataFilter.column"
                >{{dataFilter.name}}</option>
            </select>
        </div>
        <div class="grid-body p-0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="pointer" @click="sort('id')" width="150">
                            Fabric
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('out_of_stock_date')" width="150">
                            Est. Sold out date 
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('available_stock')" width="120">
                            Free stock 
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('future')" width="150">
                            Future selection (keep/out)
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('placed_order')" width="120">
                            Placed order (yes/no)
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(fabric,index) in filteredFabrics" :key="index">
                        <td><router-link :to="'/fabric/update/'+fabric.id"> {{$Fabric.getCode(fabric.id)}} - {{fabric.name}}</router-link></td>
                        <td class="text-center">{{formatOutOfStockDate(fabric)}}</td>
                        <td class="text-center">{{fabric.in_stock.toFixed(2)}} m</td>
                        <td class="text-center">{{fabric.future}}</td>
                        <td class="text-center">{{fabric.placed_order}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import FabricCalculationInfo from "./FabricCalculationInfo"
export default {
    props: ['pageData'],
    components: {FabricCalculationInfo},
    data() {
        return {
            originalFabrics: [],
            filteredFabrics: [],
            sortType: 'asc',
            future: 'all',
            date: 'all',
            futureFilterOptions: [
                {'name': 'All', 'value': 'all'},
                {'name': 'Future keep', 'value': 'keep'},
                {'name': 'Future out', 'value': 'out'},
            ],
            dateFilterOptions: [
                {'name': 'Next 2 weeks', 'value': '2'},
                {'name': 'Next 4 weeks', 'value': '4'},
                {'name': 'Next 6 weeks', 'value': '6'},
                {'name': 'All', 'value': 'all'},
            ],

        }
    },
    methods: {
        sort(column) {
            this.sortType        = (this.sortType == 'asc') ? 'desc' : 'asc';
            this.filteredFabrics =  _.orderBy(this.filteredFabrics, [column], [this.sortType]);
        },
        dateFilter(fabrics) {
            if(this.date == 'all') {
                return fabrics;
            } else {
                return fabrics.filter((fabric) => {
                    let outOfStockDate = moment.unix(fabric.out_of_stock_date);
                    let today = moment();
                    let endDate = moment().add(this.date, 'weeks');

                    return outOfStockDate.isBetween(today, endDate, null, '[]'); // The fourth argument, '[]', specifies that the comparison should be inclusive of the start and end dates.
                });
            }
        },
        futureFilter(fabrics) {
            if(this.future == 'all') {
                return fabrics;
            } else {
                return fabrics.filter(fabric => fabric.future == this.future)
            }
        },
        filterFabrics() {
            let fabrics = this.originalFabrics;
            fabrics = this.dateFilter(fabrics);
            fabrics = this.futureFilter(fabrics);
            this.filteredFabrics = fabrics;
        },
        formatOutOfStockDate(fabric) {
            if(fabric.pieces_available || fabric.always_available) {
                return 'Overwritten'
            } else if(fabric.out_of_stock_date > 0 ){
                return moment.unix(fabric.out_of_stock_date).format('DD MMM, YYYY')
            } else {
                return 'Something wrong'
            }
        }
    },
    watch: {
        'pageData.soonSoldOut': function() {
            let fabrics = this.pageData.soonSoldOut.map((fabric) => {
                if(fabric.out_of_stock_date == null || fabric.pieces_available || fabric.always_available) {
                    fabric.out_of_stock_date = -1;
                }
                return fabric;
            });
            if(fabrics) {
                let sortedFabrics = _.orderBy(fabrics, 'out_of_stock_date', [this.sortType]);
                this.originalFabrics = sortedFabrics;
                this.filteredFabrics = sortedFabrics;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.grid-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;

    h4 {
        margin-top: 0;
    }
}

.filters {
    background-color: #5e72e4;
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid white;
    align-items: center;
    padding: 20px;
    height: 40px;

    .tabs {
        display: flex;
        align-items: center;
        flex: 1;

        .tab {
            color: white;
            font-weight: bold;
            display: flex;
            height: 30px;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            padding: 0 20px;
            cursor: pointer;
            border-radius: 13px;
            border: 1px solid #ffffff58;

            &:not(:first-child) {
                margin-left: 10px;
            }

            &:hover {
                background-color: #838282a3;
            }

            &.active {
                color: #5e72e4;
                background-color: white;
                border-color: white;
            }
        }
    }
    
    select {
        border-radius: 25px;
        border-radius: 13px !important;
        color: #5e72e4;
        font-weight: 600;
        padding: 0 10px !important;
        width: auto;
        height: 30px !important;
        min-height: 30px;
        font-size: 12px;
    }
}


</style>